import { useEffect } from "react";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import {
  isDeviceSyncAvailable,
  tryAutoSync,
  onDeviceConnected,
} from "../services/deviceSyncService";

let JStyle = null;
if (Capacitor.isNativePlatform()) {
  JStyle = require("../JStylePlugin").default;
}

/**
 * Registers global device sync triggers for logged-in native sessions:
 * - app launch (hook mount)
 * - app resume (Capacitor App plugin)
 * - BLE connection established
 */
const useDeviceAutoSync = () => {
  useEffect(() => {
    if (!isDeviceSyncAvailable() || !JStyle) {
      return undefined;
    }

    const isLoggedIn = localStorage.getItem("user_info") !== null;
    const hasPairedDevice = localStorage.getItem("jstyle_address") !== null;
    if (!isLoggedIn || !hasPairedDevice) {
      return undefined;
    }

    tryAutoSync("app_launch");

    const connectionListener = JStyle.addListener(
      "connectionResult",
      () => {
        onDeviceConnected();
      }
    );

    const appStateListener = App.addListener("appStateChange", ({ isActive }) => {
      if (isActive) {
        tryAutoSync("app_resume");
      }
    });

    return () => {
      connectionListener.then((handle) => handle.remove());
      appStateListener.then((handle) => handle.remove());
    };
  }, []);
};

export default useDeviceAutoSync;
